export default __webpack_public_path__ + "static/media/rupee-icon-36c6b81ac5a25ea1654adc4e6313d506.png";